export const THREADS_ORDER = [
  {
    value: 'recent',
    label: 'Most recent',
    pathname: '/mail',
  },
  {
    value: 'unlocked',
    label: 'Unlocked',
    pathname: '/mail/unlocked',
  },
  {
    value: 'locked',
    label: 'Locked',
    pathname: '/mail/locked',
  },
  {
    value: 'archive',
    label: 'Archived',
    pathname: '/mail/archive',
  },
  {
    value: 'unread',
    label: 'Unread',
    pathname: '/mail/unread',
  },
];
